import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MapComponent} from './map.component';
import {LeafletModule} from '@asymmetrik/ngx-leaflet';
import {MapControlsComponent} from './map-controls/map-controls.component';
import {MapInterventionPopupComponent} from './map-intervention-popup/map-intervention-popup.component';
import {DxButtonModule, DxLoadIndicatorModule} from 'devextreme-angular';
import {PulseDotModule} from 'shared';
import {LeafletDrawModule} from '@asymmetrik/ngx-leaflet-draw';
import {MapLayersControlModule} from './map-layers-control/map-layers-control.module';

@NgModule({
  declarations: [MapComponent, MapControlsComponent, MapInterventionPopupComponent],
    imports: [
        CommonModule,
        LeafletModule,
        LeafletDrawModule,
        DxButtonModule,
        PulseDotModule,
        DxLoadIndicatorModule,
        MapLayersControlModule,
    ],
  exports: [MapComponent, MapInterventionPopupComponent]
})
export class MapModule {
}
